<template lang="pug">
client-only
  //- TODO: Xで公式ボタンが出てきたら公式ボタンの仕様次第で「x-button」部分を公式のクラス名に書き換える必要があるかも。
  a.x-button(:href="`http://twitter.com/share?url=${encodeURIComponent(snsUrl)}&text=${encodeURIComponent(title)}`" :class="{'border': border === '1'}" target="_blank")
    sns-twitter-svg
    span
      | {{ buttonText }}
</template>

<script>
import SnsTwitterSvg from '~/assets/images/svg/sns_twitter.svg?inline'
export default {
  components: {
    SnsTwitterSvg
  },
  props: {
    title: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: 'ポスト'
    },
    currentPath: {
      type: String,
      required: false,
      default: ''
    },
    border: {
      type: String,
      required: false,
      default: '0'
    }
  },
  data() {
    return {
      snsUrl: ''
    }
  },
  mounted() {
    // TODO: 後日公式がボタン提供開始したら差し替え
    this.$nextTick(() => {
      // eslint-disable-next-line
      window.twttr = (function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {}; if (d.getElementById(id)) return t; js = d.createElement(s); js.id = id; js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs); t._e = []; t.ready = function(f) { t._e.push(f); }; return t; }(document, "script", "twitter-wjs"))
      this.setUrl()
      const timer = setInterval(() => {
        if (window.twttr && window.twttr.widgets) {
          window.twttr.widgets.load()
          clearInterval(timer)
        }
      }, 100)
    })
  },
  methods: {
    setUrl() {
      if (this.currentPath) {
        this.snsUrl = location.origin + this.currentPath
        return
      }
      this.snsUrl = location.href
    }
  }
}
</script>
<style lang="scss" scoped>
.x-button {
  font-size: 11px;
  display: inline-block;
  color: #fff;
  background: $twitter;
  height: 20px;
  line-height: 20px;
  text-decoration: none;
  border-radius: 3px;
  display: flex;
  padding: 0 20px 0 16px;
  &.border {
    border: solid 1px #333;
    height: 22px;
  }
  svg {
    width: 14px !important;
    height: auto !important;
    fill: #fff !important;
    margin-right: 5px;
  }
  span {
    display: inline-block;
    line-height: 20px;
    letter-spacing: 0.1em;
  }
}
</style>
